var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletFloatingDisconnected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-152.032 -96.796)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M174.032,99.708a2.886,2.886,0,0,0-.868-2.059,2.991,2.991,0,0,0-2.1-.853H155a2.991,2.991,0,0,0-2.1.853,2.886,2.886,0,0,0-.868,2.059v14.177a2.885,2.885,0,0,0,.868,2.059,2.991,2.991,0,0,0,2.1.853h16.072a2.991,2.991,0,0,0,2.1-.853,2.885,2.885,0,0,0,.868-2.059v-3.626H167.59a3.556,3.556,0,0,1-2.492-1.014,3.419,3.419,0,0,1,0-4.9,3.557,3.557,0,0,1,2.492-1.014h6.442Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M399.272,248.378a1.849,1.849,0,1,1-2.122-1.529,1.849,1.849,0,0,1,2.122,1.529",
    transform: "translate(-230.042 -141.879)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletFloatingDisconnected);
export default __webpack_public_path__ + "static/media/wallet-floating-disconnected.9ac8c156bd446148539b62d0ce8872a2.svg";
export { ForwardRef as ReactComponent };